"use client";

import ReactMarkdown from "react-markdown";
import remarkGfm from "remark-gfm";

import { getMarketingMarkdownComponents } from "@/components/markdown/marketing-markdown";

interface MarketingArticleBodyProps {
  content: string;
}

// Shared markdown body for every marketing long-form page (blog posts, what's
// new entries, customer stories) so they render identically and cannot drift.
export default function MarketingArticleBody({
  content,
}: MarketingArticleBodyProps) {
  const components = getMarketingMarkdownComponents({ withHeadingIds: true });

  return (
    <div className="prose prose-lg dark:prose-invert mx-auto max-w-4xl">
      <ReactMarkdown components={components} remarkPlugins={[remarkGfm]}>
        {content}
      </ReactMarkdown>
    </div>
  );
}
